<template>
    <v-card :loading="loading">
        <v-card-title class="grey lighten-2 text-h5 font-weight-bold">
            UTC
            <v-spacer />
            <v-btn icon color="black" outlined @click="refresh">
                <v-icon>mdi-refresh</v-icon>
            </v-btn>
        </v-card-title>
        <v-skeleton-loader
            type="list-item-avatar@8"
            v-if="loading"
        ></v-skeleton-loader>
        <v-container v-else fluid>
            <v-row justify="space-around">
                <v-col cols="12" :lg="$vuetify.breakpoint.width > 1742 ? 'auto' : 12" align-self="center" class="text-center">
                    <v-avatar
                        color="primary"
                        :size="count_total >= '100' ? '220' : '150'"
                        class="gradient-wintech font-weight-black text-h1"
                    >
                        {{ count_total }}
                    </v-avatar>
                    <p class="font-weight-black text-h5 mt-3">
                        {{ $vuetify.lang.t('$vuetify.dashboard.statusCard.device') }}{{ count_total > 1 ? "s" : "" }} {{ $vuetify.lang.t('$vuetify.dashboard.statusCard.monitored') }}{{ count_total > 1 && $vuetify.lang.current === 'fr' ? "s" : "" }}
                    </p>
                </v-col>
                <v-col cols="12" sm="6" :lg="$vuetify.breakpoint.width > 1742 ? 'auto' : 6">
                    <v-card flat>
                        <v-row align="center" justify="center" no-gutters>
                            <v-col cols="auto">
                                <v-icon>mdi-hospital-box</v-icon>
                            </v-col>
                            <v-col cols="auto">
                                <v-card-title>{{$vuetify.lang.t('$vuetify.dashboard.statusCard.status')}}</v-card-title>
                            </v-col>
                        </v-row>
                        <v-timeline dense reverse>
                            <v-timeline-item
                                large
                                fill-dot
                                color="transparent"
                                v-for="(info, i) in infos"
                                :key="i"
                            >
                                <template slot="icon">
                                    <v-img :src="require(`@/assets/utc2d_${info.color}.png`)"></v-img>
                                </template>
                                <v-alert
                                    dense
                                    v-ripple
                                    :color="info.color"
                                    :outlined="info.color == 'green' || info.count == 0"
                                    :type="info.color !== 'green' && info.count > 0 ? 'error' : 'success'"
                                    :icon="false"
                                    class="text-center pointer-cursor mb-0"
                                    @click="() => { if(info.count>0) redirectToUTCs(info)}"
                                >
                                    <span class="font-weight-black text-h5">{{ info.count }}</span>
                                    <br>
                                    {{ $vuetify.lang.t(info.text) }}
                                </v-alert>
                            </v-timeline-item>
                        </v-timeline>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" :lg="$vuetify.breakpoint.width > 1742 ? 'auto' : 6">
                    <v-card flat>
                        <v-row align="center" justify="center" no-gutters>
                            <v-col cols="1">
                                <v-icon>mdi-tools</v-icon>
                            </v-col>
                            <v-col cols="auto">
                                <v-card-title>{{$vuetify.lang.t('$vuetify.dashboard.statusCard.maintenance')}}</v-card-title>
                            </v-col>
                        </v-row>
                        <v-alert
                            v-for="(maintenance, i) in maintenances"
                            :key="i"
                            dense
                            prominent
                            v-ripple
                            :outlined="maintenance.count == 0"
                            :icon="maintenance.icon"
                            class="gradient-wintech text-center"
                            :class="[{'pointer-cursor': maintenance.count>0}, maintenance.class]"
                            @click="() => { if(maintenance.count>0) redirectToUTCs(maintenance)}"
                        >
                            <span class="font-weight-black text-h5" v-if="maintenance.count>0">{{ maintenance.count }}</span>
                            <span class="font-weight-black text-h6" v-else>{{ $vuetify.lang.t('$vuetify.dashboard.statusCard.no') }}</span>
                            <br>
                            {{ $vuetify.lang.t(maintenance.text) }}
                        </v-alert>
                    </v-card>
                    <v-card flat>
                        <v-container class="pa-0">
                            <v-row align="center" justify="center" no-gutters>
                                <v-col cols="1">
                                    <v-icon>mdi-home</v-icon>
                                </v-col>
                                <v-col cols="auto">
                                    <v-card-title>{{$vuetify.lang.t('$vuetify.dashboard.statusCard.renting')}}</v-card-title>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-alert
                            dense
                            prominent
                            v-ripple
                            :outlined="rental.count == 0"
                            icon="mdi-lock-clock"
                            class="gradient-wintech text-center mb-0"
                            :class="rental.count>0 ? 'pointer-cursor' : 'default-cursor'"
                            @click="() => { if(rental.count>0) redirectToUTCs(rental)}"
                        >
                            <span class="font-weight-black text-h5" v-if="rental.count > 0">{{ rental.count }}</span>
                            <span class="font-weight-black text-h6" v-else>{{ $vuetify.lang.t('$vuetify.dashboard.statusCard.no') }}</span>
                            <br>
                            {{ rental.count > 1 ? $vuetify.lang.t('$vuetify.dashboard.statusCard.multipleexpiration') : $vuetify.lang.t('$vuetify.dashboard.statusCard.singleexpiration') }}
                        </v-alert>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
    name: "StatusCard",
    data() {
        return {
            loading: true,
            count_total: 0,
            orga: 1,
            infos: [
                { key: "status", value: "critical", count: 0, color: "red", text: '$vuetify.dashboard.statusCard.critical' },
                { key: "status", value: "warning", count: 0, color: "orange", text: '$vuetify.dashboard.statusCard.warning' },
                { key: "status", value: "ok", count: 0, color: "green", text: '$vuetify.dashboard.statusCard.ok' },
            ],
            maintenances: [
                { key: "battery", value: "expiration", count: 0, icon: "mdi-battery-heart-outline", text: '$vuetify.dashboard.statusCard.batteryreplacementneeded', class: "" },
                { key: "calibration", value: "expiration", count: 0, icon:"mdi-target", text: '$vuetify.dashboard.statusCard.returnforcalibrationneeded' , class: "mb-0" } 
            ],
            rental: { key: "rental", value: "expiration", count: 0 }
        }
    },
    computed: {
        ...mapGetters({user: "StateUser"})
    },
    mounted() {
        this.$root.$on('refreshDash', () => {
            this.refresh()
        }),
        this.refresh();
    },
    methods: {
        async refresh() {
            this.loading = true;
            try {
                const res = await axios.get('dashboard/1/'+this.user.orga);
                if (res.status == 200) {
                    this.count_total = res.data.count_total;
                    this.infos[0].count = res.data.count_critical;
                    this.infos[1].count = res.data.count_warning;
                    this.infos[2].count = res.data.count_ok;
                    this.maintenances[0].count = res.data.count_battery;
                    this.maintenances[1].count = res.data.count_calibration;
                    this.rental.count = res.data.count_expires;
                }
            } catch(err) {
                console.error(err);
            }
            setTimeout(() => {
                this.loading = false;
            }, 300);
        },
        redirectToUTCs: function(info) {
            let query = {};
            query[info.key] = info.value;
            this.$router.push({ path: "utc", query: query });
        },
        redirectToDeals: function() {
            this.$router.push("deal");
        }
    }
}
</script>
<style scoped>
    .pointer-cursor {
        cursor: pointer;
    }
    .default-cursor {
        cursor: default;
    }
    .v-timeline-item >>> .v-timeline-item__dot {
        box-shadow: none !important;
    }
</style>
